import type { Identifier } from "ra-core";
import { createContext, type ReactNode } from "react";

import { useTeamContacts } from "./useTeamContacts";

/** Phones of a whole list page (sales id -> E.164), shared with its rows. */
export const TeamContactsContext = createContext<Record<string, string> | null>(
  null,
);

/**
 * Looks the phones of every visible responsable up with ONE
 * `team_member_contacts` call and shares them with the `TeamContactActions`
 * below, instead of one request per row.
 */
export const TeamContactsProvider = ({
  salesIds,
  children,
}: {
  salesIds: Identifier[];
  children: ReactNode;
}) => {
  const { phones } = useTeamContacts(salesIds);
  return (
    <TeamContactsContext.Provider value={phones}>
      {children}
    </TeamContactsContext.Provider>
  );
};
